import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-563a17c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Export", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BaseCustomDropdown = _resolveComponent("BaseCustomDropdown")!

  return (_openBlock(), _createBlock(_component_BaseCustomDropdown, {
    class: "export-dropdown-container",
    "data-testid": "export-dropdown",
    items: _ctx.items,
    enabled: _ctx.enabled,
    "options-width": 160,
    "options-align": "center",
    "on-select": _ctx.onSelectInternal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          class: "download-icon",
          icon: ['fas', 'file-download']
        }),
        _hoisted_2,
        _createVNode(_component_font_awesome_icon, {
          class: "down-icon",
          icon: ['fas', 'chevron-down']
        })
      ])
    ]),
    _: 1
  }, 8, ["items", "enabled", "on-select"]))
}